export enum Error {
  Default = 'Default',
  MaxFiles = 'MaxFiles',
  Type = 'Type',
  Size = 'Size',
  UploadFile = 'UploadFile'
}
